import { useState, useEffect } from 'react'
import * as posts from '../services/posts.js'

const siteUrl = import.meta.env.VITE_SITE_URL

export default function Sitemap() {
  const [urls, setUrls] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadSitemapData()
  }, [])

  const loadSitemapData = async () => {
    try {
      const data = await posts.getSitemapData()
      setUrls(data || [])
    } catch (err) {
      console.error('Failed to load sitemap data:', err)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return null
  }
  
  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>${siteUrl}</loc>
    <lastmod>${new Date().toISOString()}</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  ${urls.map(url => {
    const loc = url.type === 'product' ? `${siteUrl}/product/${url.slug}` : `${siteUrl}/post/${url.slug}`
    return `<url>
    <loc>${loc}</loc>
    <lastmod>${new Date(url.updatedAt).toISOString()}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>`
  }).join('\n  ')}
</urlset>`

  return (
    <pre 
      style={{ 
        background: '#f5f5f5', 
        padding: '2rem',
        margin: '2rem',
        borderRadius: '8px',
        overflow: 'auto',
        maxHeight: '80vh',
        fontFamily: 'monospace',
        fontSize: '0.875rem'
      }}
    >
      {sitemap}
    </pre>
  )
}
